import { render } from "./EmployeeAnnouncements.vue?vue&type=template&id=50f917e8&scoped=true"
import script from "./EmployeeAnnouncements.vue?vue&type=script&lang=js"
export * from "./EmployeeAnnouncements.vue?vue&type=script&lang=js"

import "./EmployeeAnnouncements.vue?vue&type=style&index=0&id=50f917e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f917e8"]])

export default __exports__